import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	ICreateSubCategoryContext,
	CreateSubCategoryContext,
} from '../../../../../../createSubCategoryState/createSubCategoryContext';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfSubCategory,
		IDsOfRestaurantsWhereToHide,
		IDsOfRestaurantsAvailableForRepetition,
	} = useContext<ICreateSubCategoryContext>(CreateSubCategoryContext);
	const containerClasses = classNames(style.container, {
		[style.visible]:
			IDSelectedCustomer ||
			IDsSelectedRestaurant.length ||
			nameOfSubCategory ||
			IDsOfRestaurantsWhereToHide.length ||
			IDsOfRestaurantsAvailableForRepetition.length,
	});

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
